module.exports = __webpack_public_path__ + "img/flame_1.8ac923ee.png";